<template>
  <v-app>
    <v-img
      contain
      max-height="200"
      class="pink--text"
      :src="require('../assets/virtuaalijono_added.svg')"
    ></v-img>
    <div clas="text-center">
      <v-card-title class="layout align-center fill-height margin-block">
        <h1>Olette virtuaalijonossa</h1>
      </v-card-title>
      <v-card-text class="narrow-content">
        <div class="attention info-row">
          <h3 class="queue-time-header">Vuoronumero</h3>
          <div class="queue-time-value">{{ slotNumber }}</div>
          <div class="info-row">
            <h3 class="queue-time-header">Arvioitu aika</h3>
            <div class="queue-time-value">{{ slotTime }}</div>
          </div>
          <div class="info-row">
            <h3 class="queue-time-header">Ryhmän koko</h3>
            <div class="queue-time-value">{{ groupSize }}</div>
          </div>
          <div class="info-row">
            <h3 class="queue-time-header">Puhelinnumero</h3>
            <div class="queue-time-value">{{ phone }}</div>
          </div>
        </div>
        <p>
          <strong>
            Saavuttehan Tukkijoelle ajoissa ennen vuoroanne.
            Saamasi tekstiviesti toimii vahvistuksena, joka tulee näyttää laitekuljettajalle.
            Virtuaalijonottajat siirtyvät laitteeseen Tukkifoton edestä.
          </strong>
        </p>
        <p>
          Tukkijoessa käynnin jälkeen pyydämme teitä osallistumaan palautteenantoon Tukkifoton vieressä.
          Osallistumisesta palkkiona on Särkänniemen vapaalippu.
        </p>
        <div class="narrow-content">
          <v-btn
            text
            color="#00B0EE"
            width="100%"
            class="margin-block"
            @click="gotoInfo()"
          >Lisätietoja</v-btn>
        </div>
      </v-card-text>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Queue',
  computed: mapGetters(['slotTime', 'slotNumber', 'phone', 'groupSize']),
  beforeMount: function() {
    if (this.slotNumber === '-' || this.slotNumber === undefined) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    gotoInfo: function() {
      this.$router.push({ path: 'info' });
    },
  },
};
</script>

<style>
.info-row {
  margin: 40px 0;
  font-weight: bold;
  text-align: center;
}

.info-row > .label {
  color: #00b0ee;
  font-size: 20px;
}

.info-row > .value {
  font-size: 24px;
}

.disclaimer {
  font-weight: bold;
}
</style>